import React from "react";
import { useNavigate } from "react-router-dom";
import "./BackButton.css";

function BackButton({ label = "Back", size = "md" }) {
  const navigate = useNavigate();
  return (
    <button
      className={`back-button ${size === "sm" ? "back-button--sm" : ""}`}
      onClick={() => navigate(-1)}
    >
      ← {label}
    </button>
  );
}

export default BackButton;
